import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";
import { AddToCartIcon } from "../_icons/addToCartIcon";
import { useTranslations } from "next-intl";

export const ItemsAddedToCartBanner = () => {
  const t = useTranslations("ItemsAddedToCartBanner");
  return (
    <div
      data-testid={applyDataTestId(pom.scanToOrder.itemsAddedToCartBanner)}
      className="bg-[#F2FCEE] rounded-lg border border-[#228800] w-[249px] gap-4 flex p-3"
    >
      <AddToCartIcon />
      <div>
        <p className="font-medium text-[15px] pb-2">{t("title")}</p>
        <p className="text-[14px]">{t("message")}</p>
      </div>
    </div>
  );
};
